<template>
  <component :is="icon" :class="['svg-icon', size]" />
</template>

<script setup lang="ts">
import { defineAsyncComponent, shallowRef, watch } from 'vue';

import { IconName } from '../values/icons.const';

interface IconProps {
  name: IconName;
  size?: 'large' | 'medium' | 'small' | 'extra-small';
}

const props = withDefaults(defineProps<IconProps>(), { size: 'medium' });
const icon = shallowRef(null);

watch(
  () => props.name,
  () => {
    icon.value = defineAsyncComponent(() => import(`icons/${props.name}.svg?component`));
  },
  { immediate: true },
);
</script>

<style scoped lang="scss">
.svg-icon {
  width: var(--t-icon-size);
  height: var(--t-icon-size);
  stroke: currentColor;

  &.extra-small {
    --t-icon-size: 1rem;
  }

  &.small {
    --t-icon-size: 1.25rem;
  }

  &.medium {
    --t-icon-size: 1.5rem;
  }

  &.large {
    --t-icon-size: 2.5rem;
  }
}
</style>
